module.exports = __webpack_public_path__ + "img/classic_season20_3.dd39a7c2.jpg";